import { render, staticRenderFns } from "./WhatsAppAccounts.vue?vue&type=template&id=95340134&scoped=true&"
import script from "./WhatsAppAccounts.vue?vue&type=script&lang=js&"
export * from "./WhatsAppAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95340134",
  null
  
)

export default component.exports